<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1>Competition </h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
 <section class="section-md">
   <div class="container">
       <div class="row g-5 row-cols-1 row-cols-lg-2">
        <div class="col-lg-3">
          <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
            <li class="nav-item" role="presentation">
              <button class="nav-link active" id="pills-wrestling-championships-tab" data-bs-toggle="pill"
                data-bs-target="#pills-wrestling-championships" type="button" role="tab" aria-controls="pills-wrestling-championships"
                aria-selected="true" >Wrestling Championships </button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link" id="pills-slum-soccer-tab" data-bs-toggle="pill"
                data-bs-target="#pills-slum-soccer" type="button" role="tab" aria-controls="pills-slum-soccer"
                aria-selected="true" >Slum Soccer </button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link" id="pills-pubg-competition-tab" data-bs-toggle="pill" data-bs-target="#pills-pubg-competition"
                type="button" role="tab" aria-controls="pills-pubg-competition" aria-selected="false">PUBG Competition
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link" id="pills-talent-tab" data-bs-toggle="pill" data-bs-target="#pills-talent"
                type="button" role="tab" aria-controls="pills-talent" aria-selected="false">I Too Have A Talent </button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link" id="pills-dress-designing-tab" data-bs-toggle="pill" data-bs-target="#pills-dress-designing"
                type="button" role="tab" aria-controls="pills-dress-designing" aria-selected="false">Dress Designing Competition</button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link" id="pills-lokmat-chess-tab" data-bs-toggle="pill" data-bs-target="#pills-lokmat-chess"
                type="button" role="tab" aria-controls="pills-lokmat-chess" aria-selected="false">Lokmat Chess Competition</button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link" id="pills-player-orbit-tab" data-bs-toggle="pill" data-bs-target="#pills-player-orbit"
                type="button" role="tab" aria-controls="pills-player-orbit" aria-selected="false">PlayerOrbit</button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link" id="pills-armsport-tab" data-bs-toggle="pill" data-bs-target="#pills-armsport" type="button" role="tab" aria-controls="pills-armsport" aria-selected="false">Armsport</button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link" id="pills-swimming-tab" data-bs-toggle="pill" data-bs-target="#pills-swimming" type="button" role="tab" aria-controls="pills-swimming" aria-selected="false">Swimming</button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link" id="pills-basket-tab" data-bs-toggle="pill" data-bs-target="#pills-basket" type="button" role="tab" aria-controls="pills-basket" aria-selected="false">Maha Basket State Championship</button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link" id="pills-archery-tab" data-bs-toggle="pill" data-bs-target="#pills-archery" type="button" role="tab" aria-controls="pills-archery" aria-selected="false">Archery Tournament - Amravati , Pune, Nagpur</button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link" id="pills-love-nation-tab" data-bs-toggle="pill" data-bs-target="#pills-love-nation" type="button" role="tab" aria-controls="pills-love-nation" aria-selected="false">I Too Love My Nation</button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link" id="pills-football-tab" data-bs-toggle="pill" data-bs-target="#pills-football" type="button" role="tab" aria-controls="pills-football" aria-selected="false">Football Tournament</button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link" id="pills-table-tennis-tab" data-bs-toggle="pill" data-bs-target="#pills-table-tennis" type="button" role="tab" aria-controls="pills-table-tennis" aria-selected="false">Table Tennis</button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link" id="pills-futsal-tab" data-bs-toggle="pill" data-bs-target="#pills-futsal" type="button" role="tab" aria-controls="pills-futsal" aria-selected="false">Futsal Tournament</button>
            </li>
          </ul>
        </div>
        <div class="col-lg-9">
          <div class="tab-content" id="pills-tabContent">
            <div class="tab-pane fade show active" id="pills-wrestling-championships" role="tabpanel" aria-labelledby="pills-wrestling-championships-tab">
              <div class="university campus-buzz">
                <div class="row justify-content-center">
                  <div class="col-md-12">
                    <nav class="nav nav-pills d-flex justify-content-center mb-5">
                      <a href="javascript:void(0)" class="nav-link active" (click)="filterInnerTabs('all', $event, 'inner-tab-events-wrestling-championships')">All</a>
                      <a href="javascript:void(0)" class="nav-link" (click)="filterInnerTabs('2025', $event, 'inner-tab-events-wrestling-championships')">2025</a>
                    </nav>
                  </div>
                </div>
                <div class="row row-cols-lg-2 row-cols-md-2 row-cols-2 justify-content-center g-3" id="inner-tab-events-wrestling-championships">

                    <div class="col" data-year="2025">
                    <div class="card border-light shadow-soft">
                      <div class="card-header p-3 shadow-inset image-effect-1">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/wrestling-championships-25/wrestling-championships-25.webp"
                          class="card-img-top rounded" alt="GHRSCF">
                      </div>
                      <div class="card-body pt-2">
                        <div class="event-date">
                          <i class="fa fa-calendar-o" aria-hidden="true"></i>
                          <span>21th to 22th, June 2025</span>
                        </div>
                        <h3 class="h5 card-title">
                          Wrestling Championships 2025
                        </h3>
                        <p class="card-text">
                        Raisoni Foundation, in collaboration with Nagpur Municipal Corporation, successfully hosted a state-level U-15 Wrestling Competition — bringing together young talent, discipline, and sportsmanship under one mat.
                        </p>
                        <div class="d-flex justify-content-between">
                          <a routerLink="/wrestling-championships-twenty-five" class="cmn-button">
                            Read More
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="pills-slum-soccer" role="tabpanel" aria-labelledby="pills-slum-soccer-tab">
              <div class="university campus-buzz">
                <div class="row justify-content-center">
                  <div class="col-md-12">
                    <nav class="nav nav-pills d-flex justify-content-center mb-5">
                      <a href="javascript:void(0)" class="nav-link active" (click)="filterInnerTabs('all', $event, 'inner-tab-events-slum-soccer')">All</a>
                      <!-- <a href="javascript:void(0)" class="nav-link" (click)="filterInnerTabs('2025', $event, 'inner-tab-events-slum-soccer')">2025</a> -->
                      <a href="javascript:void(0)" class="nav-link" (click)="filterInnerTabs('2022', $event, 'inner-tab-events-slum-soccer')">2022</a>
                    </nav>
                  </div>
                </div>
                <div class="row row-cols-lg-2 row-cols-md-2 row-cols-2 justify-content-center g-3" id="inner-tab-events-slum-soccer">

                    <div class="col" data-year="2022">
                    <div class="card border-light shadow-soft">
                      <div class="card-header p-3 shadow-inset image-effect-1">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/slub-soccer.png"
                          class="card-img-top rounded" alt="GHRSCF">
                      </div>
                      <div class="card-body pt-2">
                        <div class="event-date">
                          <i class="fa fa-calendar-o" aria-hidden="true"></i>
                          <span>August 2022</span>
                        </div>
                        <h3 class="h5 card-title">
                          Slum Soccer Social Inclusion Intercollegiate Soccer Tournament
                        </h3>
                        <p class="card-text">
                          RGI collaborated with Slum Soccer- Krida Vikas
                          Sanstha to celebrate Sports Day.
                        </p>
                        <div class="d-flex justify-content-between">
                          <a routerLink="/slum-soccer" class="cmn-button">
                            Read More
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="pills-pubg-competition" role="tabpanel" aria-labelledby="pills-pubg-competition-tab">
              <div class="university campus-buzz">
                <div class="row justify-content-center">
                  <div class="col-md-12">
                    <nav class="nav nav-pills d-flex justify-content-center mb-5">
                      <a href="javascript:void(0)" class="nav-link active" (click)="filterInnerTabs('all', $event, 'inner-tab-events-pubg-competition')">All</a>
                      <a href="javascript:void(0)" class="nav-link" (click)="filterInnerTabs('2019', $event, 'inner-tab-events-pubg-competition')">2019</a>
                      <!-- <a href="javascript:void(0)" class="nav-link" (click)="filterInnerTabs('2024', $event, 'inner-tab-events-pubg-competition')">2024</a> -->
                    </nav>
                  </div>
                </div>
                <div class="row row-cols-lg-2 row-cols-md-2 row-cols-21 justify-content-center g-3"  id="inner-tab-events-pubg-competition">
                   <div class="col" data-year="2019">
                    <div class="card border-light shadow-soft">
                      <div class="card-header p-3 shadow-inset image-effect-1">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/eve-2.webp"
                          class="card-img-top rounded" alt="GHRSCF">
                      </div>
                      <div class="card-body pt-2">
                        <div class="event-date">
                          <i class="fa fa-calendar-o" aria-hidden="true"></i>
                          <span>April 05, 2019</span>
                        </div>
                        <h3 class="h5 card-title">PUBG Competition</h3>
                        <p class="card-text">Online PUBG Competition</p>
                        <p class="card-text">PUBG the sensational game hit with the Youth</p>
                        <div class="d-flex justify-content-between">
                          <a routerLink="/pubg" class="cmn-button">
                            Read More
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="pills-talent" role="tabpanel" aria-labelledby="pills-talent-tab">
              <div class="university campus-buzz">
                <div class="row justify-content-center">
                  <div class="col-md-12">
                   <nav class="nav nav-pills d-flex justify-content-center mb-5">
                      <a href="javascript:void(0)" class="nav-link active" (click)="filterInnerTabs('all', $event, 'inner-tab-events-talent')">All</a>
                      <a href="javascript:void(0)" class="nav-link" (click)="filterInnerTabs('2023', $event, 'inner-tab-events-talent')">2023</a>
                      <a href="javascript:void(0)" class="nav-link" (click)="filterInnerTabs('2019', $event, 'inner-tab-events-talent')">2019</a>
                    </nav>
                  </div>
                </div>
                <div class="row row-cols-lg-2 row-cols-md-2 row-cols-2 justify-content-center g-3"  id="inner-tab-events-talent">

                  <div class="col" data-year="2023">
                      <div class="card border-light shadow-soft">
                          <div class="card-header p-3 shadow-inset image-effect-1">
                              <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/i-too-have-talent-22.jpg"
                                  class="card-img-top rounded" alt="GHRSCF" />
                          </div>
                          <div class="card-body pt-2">
                              <div class="event-date">
                                  <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                                      alt="GHRSCF" />
                                  <span> 2023</span>
                              </div>

                              <h3 class="h5 card-title">I Too Have A Talent</h3>
                              <p class="card-text">Raisoni Group always endeavors not only to nurture academic qualities of
                                  students.</p>
                              <div class="d-flex justify-content-between">
                                  <a routerLink="/itoohavetalent-2022" class="cmn-button">Read More</a>
                              </div>
                          </div>
                      </div>
                  </div>
                   <div class="col" data-year="2019">
                      <div class="card border-light shadow-soft">
                          <div class="card-header p-3 shadow-inset image-effect-1">
                              <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/com-4.webp"
                                  class="card-img-top rounded" alt="GHRSCF" />
                          </div>
                          <div class="card-body pt-2">
                              <div class="event-date">
                                  <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                                      alt="GHRSCF" />
                                  <span> 2019</span>
                              </div>
                              <h3 class="h5 card-title">I Too Have A Talent</h3>
                              <p class="card-text">Raisoni Group always endeavors not only to nurture academic qualities of
                                  students.</p>
                              <div class="d-flex justify-content-between">
                                  <a routerLink="/itoohavetalent" class="cmn-button">Read More</a>
                              </div>
                          </div>
                      </div>
                  </div>

                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="pills-dress-designing" role="tabpanel" aria-labelledby="pills-dress-designing-tab">
              <div class="university campus-buzz">
                <div class="row justify-content-center">
                  <div class="col-md-12">
                    <nav class="nav nav-pills d-flex justify-content-center mb-5">
                      <a href="javascript:void(0)" class="nav-link active" (click)="filterInnerTabs('all', $event, 'inner-tab-events-dress-designing')">All</a>
                      <a href="javascript:void(0)" class="nav-link" (click)="filterInnerTabs('2023', $event, 'inner-tab-events-dress-designing')">2023</a>
                      <!-- <a href="javascript:void(0)" class="nav-link" (click)="filterInnerTabs('2024', $event, 'inner-tab-events-dress-designing')">2024</a> -->
                    </nav>
                  </div>
                </div>
                <div class="row row-cols-lg-2 row-cols-md-2 row-cols-2 justify-content-center g-3"  id="inner-tab-events-dress-designing">


                  <div class="col"  data-year="2023">
                    <div class="card border-light shadow-soft">
                        <div class="card-header p-3 shadow-inset image-effect-1">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/dress-desigjn.jpg"
                                class="card-img-top rounded" alt="GHRSCF" />
                        </div>
                        <div class="card-body pt-2">
                            <div class="event-date">
                                <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                                    alt="GHRSCF" />
                                <span> 2023</span>
                            </div>
                            <h3 class="h5 card-title">Dress Designing Competition</h3>
                            <p class="card-text">We are pleased to invite your institute Students to participate in the
                                Dress Designing Competition</p>
                            <div class="d-flex justify-content-between">
                                <a routerLink="/dress-design" class="cmn-button"> Read More</a>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="pills-lokmat-chess" role="tabpanel" aria-labelledby="pills-lokmat-chess-tab">
              <div class="university campus-buzz">
                <div class="row justify-content-center">
                  <div class="col-md-12">
                    <nav class="nav nav-pills d-flex justify-content-center mb-5">
                      <a href="javascript:void(0)" class="nav-link active" (click)="filterInnerTabs('all', $event, 'inner-tab-events-lokmat-chess')">All</a>
                      <a href="javascript:void(0)" class="nav-link" (click)="filterInnerTabs('2021', $event, 'inner-tab-events-lokmat-chess')">2021</a>
                      <a href="javascript:void(0)" class="nav-link" (click)="filterInnerTabs('2019', $event, 'inner-tab-events-lokmat-chess')">2019</a>
                    </nav>
                  </div>
                </div>
                <div class="row row-cols-lg-2 row-cols-md-2 row-cols-2 justify-content-center g-3" id="inner-tab-events-lokmat-chess">

                  <div class="col" data-year="2021">
                     <div class="card border-light shadow-soft">
                        <div class="card-header p-3 shadow-inset image-effect-1">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/com-2.webp"
                                class="card-img-top rounded" alt="GHRSCF" />
                        </div>
                        <div class="card-body pt-2">
                            <div class="event-date">
                                <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                                    alt="GHRSCF" />
                                <span> 18<sup>th</sup>- 19<sup>th</sup> December 2021</span>
                            </div>
                            <h3 class="h5 card-title">Lokmat Chess Competition</h3>
                            <p class="card-text">District Level Rapid Chess tournament 2021 Powered by GHRaisoni Sport &
                                Cultural Froundation</p>
                            <div class="d-flex justify-content-between">
                                <a routerLink="/rapid-chess-tournament" class="cmn-button"> Read More</a>
                            </div>
                        </div>
                      </div>
                  </div>


                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="pills-player-orbit" role="tabpanel" aria-labelledby="pills-player-orbit-tab">
              <div class="university campus-buzz">
                <div class="row justify-content-center">
                  <div class="col-md-12">
                   <nav class="nav nav-pills d-flex justify-content-center mb-5">
                      <a href="javascript:void(0)" class="nav-link active" (click)="filterInnerTabs('all', $event, 'inner-tab-events-player-orbit')">All</a>
                      <a href="javascript:void(0)" class="nav-link" (click)="filterInnerTabs('2024', $event, 'inner-tab-events-player-orbit')">2024</a>
                    </nav>
                  </div>
                </div>
                <div class="row row-cols-lg-2 row-cols-md-2 row-cols-2 justify-content-center g-3" id="inner-tab-events-player-orbit">

                   <div class="col" data-year="2024">
                    <div class="card border-light shadow-soft">
                      <div class="card-header p-3 shadow-inset image-effect-1">
                        <img
                          src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/checkmate-challenge-1.avif"
                          class="card-img-top rounded" alt="GHRSCF">
                      </div>
                      <div class="card-body pt-2">
                        <div class="event-date">
                          <i class="fa fa-calendar-o" aria-hidden="true"></i>
                          <span> 10
                            <sup>th</sup> November 2024
                          </span>
                        </div>
                        <h3 class="h5 card-title"> Pune GH Raisoni Foundation & PlayerOrbit Checkmate Challenge</h3>
                        <p class="card-text">The GH Raisoni Foundation and PlayerOrbit Pune Checkmate Challenge 2024 was
                          held in Pune on November 10, 2024, at Amanora Mall, Pune.</p>
                        <div class="d-flex justify-content-between">
                          <a routerLink="/pune-checkmate-challenge" class="cmn-button">
                            Read More
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="pills-armsport" role="tabpanel" aria-labelledby="pills-armsport-tab">
              <div class="university campus-buzz">
                <div class="row justify-content-center">
                  <div class="col-md-12">
                     <nav class="nav nav-pills d-flex justify-content-center mb-5">
                      <a href="javascript:void(0)" class="nav-link active" (click)="filterInnerTabs('all', $event, 'inner-tab-events-armsport')">All</a>
                      <a href="javascript:void(0)" class="nav-link" (click)="filterInnerTabs('2024', $event, 'inner-tab-events-armsport')">2024</a>
                    </nav>
                  </div>
                </div>
                <div class="row row-cols-lg-2 row-cols-md-2 row-cols-2 justify-content-center g-3" id="inner-tab-events-armsport">

                   <div class="col" data-year="2024">
                    <div class="card border-light shadow-soft">
                      <div class="card-header p-3 shadow-inset image-effect-1">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/arm7.avif"
                          class="card-img-top rounded" alt="GHRSCF">
                      </div>
                      <div class="card-body pt-2">
                        <div class="event-date">
                          <i class="fa fa-calendar-o" aria-hidden="true"></i>
                          <span> February 2024</span>
                        </div>
                        <h3 class="h5 card-title">Armsport Competition Pune</h3>
                        <p class="card-text">G H Raisoni Sports & Cultural Foundation</p>
                        <div class="d-flex justify-content-between">
                          <a routerLink="/armsport-competition" class="cmn-button">
                            Read More
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="pills-swimming" role="tabpanel" aria-labelledby="pills-swimming-tab">
              <div class="university campus-buzz">
                <div class="row justify-content-center">
                  <div class="col-md-12">
                    <nav class="nav nav-pills d-flex justify-content-center mb-5">
                      <a href="javascript:void(0)" class="nav-link active" (click)="filterInnerTabs('all', $event, 'inner-tab-events-swimming')">All</a>
                      <a href="javascript:void(0)" class="nav-link" (click)="filterInnerTabs('2024', $event, 'inner-tab-events-swimming')">2024</a>
                    </nav>
                  </div>
                </div>
                <div class="row row-cols-lg-2 row-cols-md-2 row-cols-2 justify-content-center g-3" id="inner-tab-events-swimming">

                     <div class="col" data-year="2024">
                    <div class="card border-light shadow-soft">
                      <div class="card-header p-3 shadow-inset image-effect-1">
                        <img
                          src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/swimming_compition.avif"
                          class="card-img-top rounded" alt="GHRSCF">
                      </div>
                      <div class="card-body pt-2">
                        <div class="event-date">
                          <i class="fa fa-calendar-o" aria-hidden="true"></i>
                          <span> February 2024</span>
                        </div>
                        <h3 class="h5 card-title">Swimming competition Nagpur</h3>
                        <p class="card-text">
                          G H Raisoni Sports & Cultural Foundation Under the aegis of Nagpur District
                          Amature Aquatic
                        </p>
                        <div class="d-flex justify-content-between">
                          <a routerLink="/swimming-competition" class="cmn-button">
                            Read More
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="pills-basket" role="tabpanel" aria-labelledby="pills-basket-tab">
              <div class="university campus-buzz">
                <div class="row justify-content-center">
                  <div class="col-md-12">
                    <nav class="nav nav-pills d-flex justify-content-center mb-5">
                      <a href="javascript:void(0)" class="nav-link active" (click)="filterInnerTabs('all', $event, 'inner-tab-events-basket')">All</a>
                      <a href="javascript:void(0)" class="nav-link" (click)="filterInnerTabs('2024', $event, 'inner-tab-events-basket')">2024</a>
                    </nav>
                  </div>
                </div>
                <div class="row row-cols-lg-2 row-cols-md-2 row-cols-2 justify-content-center g-3" id="inner-tab-events-basket">

                  <!-- <div class="col"  data-year="2024">
                    <div class="card border-light shadow-soft">
                      <div class="card-header p-3 shadow-inset image-effect-1">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/eve-5.webp"
                          class="card-img-top rounded" alt="GHRSCF">
                      </div>
                      <div class="card-body pt-2">
                        <div class="event-date">
                          <i class="fa fa-calendar-o" aria-hidden="true"></i>
                          <span>January 6, 2024</span>
                        </div>
                        <h3 class="h5 card-title">SJAN &amp; Raisoni Achievers Award</h3>
                        <p class="card-text">
                          SJAN, Raisoni Group of Institutions started this Raosni Achiever's Award in
                          Collaboration.
                        </p>
                        <div class="d-flex justify-content-between">
                          <a routerLink="/sjan-award" class="cmn-button">
                            Read More
                          </a>
                        </div>
                      </div>
                    </div>
                  </div> -->

                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="pills-archery" role="tabpanel" aria-labelledby="pills-archery-tab">
              <div class="university campus-buzz">
                <div class="row justify-content-center">
                  <div class="col-md-12">
                    <nav class="nav nav-pills d-flex justify-content-center mb-5">
                      <a href="javascript:void(0)" class="nav-link active" (click)="filterInnerTabs('all', $event, 'inner-tab-events-archery')">All</a>
                      <a href="javascript:void(0)" class="nav-link" (click)="filterInnerTabs('2024', $event, 'inner-tab-events-archery')">2024</a>
                      <a href="javascript:void(0)" class="nav-link" (click)="filterInnerTabs('2023', $event, 'inner-tab-events-archery')">2023</a>
                    </nav>
                  </div>
                </div>
                <div class="row row-cols-lg-2 row-cols-md-2 row-cols-2 justify-content-center g-3" id="inner-tab-events-archery">

                  <div class="col"  data-year="2024">
                    <div class="card border-light shadow-soft">
                    <div class="card-header p-3 shadow-inset image-effect-1">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/archerynagpur.webp"
                            class="card-img-top rounded" alt="GHRSCF" />
                    </div>
                    <div class="card-body pt-2">
                        <div class="event-date">
                            <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                                alt="GHRSCF" />
                            <span> 3<sup>rd</sup> September 2023</span>
                        </div>
                        <h3 class="h5 card-title">G H Raisoni Memorial Archery Tournament, Nagpur 2023</h3>
                        <!-- <p class="card-text">Chess Association on Nagpur has the honour to invite all Chess Players from  Maharashtra</p> -->
                        <div class="d-flex justify-content-between">
                            <a routerLink="/archery-tournament-nagpur" class="cmn-button">
                                Read More
                            </a>
                        </div>
                    </div>
                    </div>
                  </div>
                  <div class="col" data-year="2023">
                    <div class="card border-light shadow-soft">
                        <div class="card-header p-3 shadow-inset image-effect-1">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/archery.webp"
                                class="card-img-top rounded" alt="GHRSCF" />
                        </div>
                        <div class="card-body pt-2">
                            <div class="event-date">
                                <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                                    alt="GHRSCF" />
                                <span> 12<sup>rd</sup> August 2023</span>
                            </div>
                            <h3 class="h5 card-title">G H Raisoni Memorial Archery Tournament, Pune</h3>
                            <!-- <p class="card-text">Chess Association on Nagpur has the honour to invite all Chess Players from  Maharashtra</p> -->
                            <div class="d-flex justify-content-between">
                                <a routerLink="/archery-tournament-pune" class="cmn-button"> Read More</a>
                            </div>
                        </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="pills-love-nation" role="tabpanel" aria-labelledby="pills-love-nation-tab">
              <div class="university campus-buzz">
                <div class="row justify-content-center">
                  <div class="col-md-12">
                    <nav class="nav nav-pills d-flex justify-content-center mb-5">
                      <a href="javascript:void(0)" class="nav-link active" (click)="filterInnerTabs('all', $event, 'inner-tab-events-love-nation')">All</a>
                      <a href="javascript:void(0)" class="nav-link" (click)="filterInnerTabs('2019', $event, 'inner-tab-events-love-nation')">2019</a>
                    </nav>
                  </div>
                </div>
                <div class="row row-cols-lg-2 row-cols-md-2 row-cols-2 justify-content-center g-3" id="inner-tab-events-love-nation">

                  <div class="col"  data-year="2019">
                    <div class="card border-light shadow-soft">
                        <div class="card-header p-3 shadow-inset image-effect-1">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/com-5.webp"
                                class="card-img-top rounded" alt="GHRSCF" />
                        </div>
                        <div class="card-body pt-2">
                            <div class="event-date">
                                <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                                    alt="GHRSCF" />
                                <span> 2019</span>
                            </div>

                            <h3 class="h5 card-title">I Too Love My Nation</h3>
                            <p class="card-text">On the occasion of Independence Day - 15 August 2019 Raisoni group
                                organized some competitions.</p>
                            <div class="d-flex justify-content-between">
                                <a routerLink="/itoolovemynation" class="cmn-button"> Read More</a>
                            </div>
                        </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="pills-football" role="tabpanel" aria-labelledby="pills-football-tab">
              <div class="university campus-buzz">
                <div class="row justify-content-center">
                  <div class="col-md-12">
                    <nav class="nav nav-pills d-flex justify-content-center mb-5">
                      <a href="javascript:void(0)" class="nav-link active" (click)="filterInnerTabs('all', $event, 'inner-tab-events-football')">All</a>
                      <a href="javascript:void(0)" class="nav-link" (click)="filterInnerTabs('2024', $event, 'inner-tab-events-football')">2024</a>
                    </nav>
                  </div>
                </div>
                <div class="row row-cols-lg-2 row-cols-md-2 row-cols-2 justify-content-center g-3" id="inner-tab-events-football">

                  <div class="col"  data-year="2024">
                    <div class="card border-light shadow-soft">
                    <div class="card-header p-3 shadow-inset image-effect-1">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/football_tour.avif"
                            class="card-img-top rounded" alt="GHRSCF" />
                    </div>
                    <div class="card-body pt-2">
                        <div class="event-date">
                            <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                                alt="GHRSCF" />
                            <span> 16<sup>th</sup> January 2024</span>
                        </div>
                        <h3 class="h5 card-title">G.H.Raisoni Football Tournament Gondia</h3>
                        <!-- <p class="card-text">Chess Association on Nagpur has the honour to invite all Chess Players from  Maharashtra</p> -->
                        <div class="d-flex justify-content-between">
                            <a routerLink="/football-tournament-2024" class="cmn-button">
                                Read More
                            </a>
                        </div>
                    </div>
                    </div>
                  </div>
                   <div class="col" data-year="2023">
                      <div class="card border-light shadow-soft">
                          <div class="card-header p-3 shadow-inset image-effect-1">
                              <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/memorial-football.webp"
                                  class="card-img-top rounded" alt="GHRSCF" />
                          </div>
                          <div class="card-body pt-2">
                              <div class="event-date">
                                  <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                                      alt="GHRSCF" />
                                  <span> 21<sup>th</sup> & 30<sup>th</sup> May 2023</span>
                              </div>
                              <h3 class="h5 card-title">G. H Raisoni Memorial Cup</h3>
                              <!-- <p class="card-text">Chess Association on Nagpur has the honour to invite all Chess Players from  Maharashtra</p> -->
                              <div class="d-flex justify-content-between">
                                  <a routerLink="/memorial-cup" class="cmn-button"> Read More </a>
                              </div>
                          </div>
                      </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="pills-table-tennis" role="tabpanel" aria-labelledby="pills-table-tennis-tab">
              <div class="university campus-buzz">
                <div class="row justify-content-center">
                  <div class="col-md-12">
                    <nav class="nav nav-pills d-flex justify-content-center mb-5">
                      <a href="javascript:void(0)" class="nav-link active" (click)="filterInnerTabs('all', $event, 'inner-tab-events-football')">All</a>
                      <a href="javascript:void(0)" class="nav-link" (click)="filterInnerTabs('2023', $event, 'inner-tab-events-football')">2023</a>
                    </nav>
                  </div>
                </div>
                <div class="row row-cols-lg-2 row-cols-md-2 row-cols-2 justify-content-center g-3" id="inner-tab-events-football">

                  <div class="col"  data-year="2023">
                     <div class="card border-light shadow-soft">
                        <div class="card-header p-3 shadow-inset image-effect-1">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/tennis-amt.webp"
                                class="card-img-top rounded" alt="GHRSCF" />
                        </div>
                        <div class="card-body pt-2">
                            <div class="event-date">
                                <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                                    alt="GHRSCF" />
                                <span> 17<sup>th</sup> September 2023</span>
                            </div>
                            <h3 class="h5 card-title">Table Tennis Tournament at GHRU, Amravati</h3>
                            <!-- <p class="card-text">Chess Association on Nagpur has the honour to invite all Chess Players from  Maharashtra</p> -->
                            <div class="d-flex justify-content-between">
                                <a routerLink="/table-tennis-amravati" class="cmn-button"> Read More </a>
                            </div>
                        </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="pills-futsal" role="tabpanel" aria-labelledby="pills-futsal-tab">
              <div class="university campus-buzz">
                <div class="row justify-content-center">
                  <div class="col-md-12">
                    <nav class="nav nav-pills d-flex justify-content-center mb-5">
                      <a href="javascript:void(0)" class="nav-link active" (click)="filterInnerTabs('all', $event, 'inner-tab-events-football')">All</a>
                      <a href="javascript:void(0)" class="nav-link" (click)="filterInnerTabs('2023', $event, 'inner-tab-events-football')">2023</a>
                    </nav>
                  </div>
                </div>
                <div class="row row-cols-lg-2 row-cols-md-2 row-cols-2 justify-content-center g-3" id="inner-tab-events-football">

                  <div class="col"  data-year="2023">
                   <div class="card border-light shadow-soft">
                    <div class="card-header p-3 shadow-inset image-effect-1">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fustaltournament.webp"
                            class="card-img-top rounded" alt="GHRSCF" />
                    </div>
                    <div class="card-body pt-2">

                        <div class="event-date">
                            <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                                alt="GHRSCF" />
                            <span> 26<sup>th</sup> and 27<sup>th</sup> August 2023</span>
                        </div>
                        <h3 class="h5 card-title">G H Raisoni Memorial Futsal Tournament – 2023</h3>
                        <!-- <p class="card-text">Chess Association on Nagpur has the honour to invite all Chess Players from  Maharashtra</p> -->
                        <div class="d-flex justify-content-between">
                            <a routerLink="/futsal-tournament" class="cmn-button"> Read More</a>
                        </div>
                    </div>
                </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
   </div>
  </section>



